import { render, staticRenderFns } from "./MenuPauses.vue?vue&type=template&id=4292a0c4&scoped=true"
import script from "./MenuPauses.vue?vue&type=script&lang=js"
export * from "./MenuPauses.vue?vue&type=script&lang=js"
import style0 from "./MenuPauses.vue?vue&type=style&index=0&id=4292a0c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4292a0c4",
  null
  
)

export default component.exports